module.exports = __webpack_public_path__ + "img/money-bag.5dc57052.png";